"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OddFormatter = void 0;
class OddFormatter {
    static defaultFormat = "Decimal";
    static asianDecimalPoint = 4;
    static autoDecimalPoint = false;
    static format = (value, format) => {
        let formatter;
        switch (format) {
            case "American":
                formatter = OddFormatter.toAmerican;
                break;
            case "Decimal":
                formatter = OddFormatter.toDecimal;
                break;
            case "Fractional":
                formatter = OddFormatter.toFractional;
                break;
            case "HongKong":
                formatter = OddFormatter.toHongKong;
                break;
            case "Indonesian":
                formatter = OddFormatter.toIndonesian;
                break;
            case "Malay":
                formatter = OddFormatter.toMalay;
                break;
            case "Probability":
                formatter = OddFormatter.toProbability;
                break;
            default:
                formatter = OddFormatter.toDecimal;
        }
        return formatter(value);
    };
    static toAmerican(odd) {
        let result;
        if (odd < 2) {
            result = -100 / (odd - 1);
        }
        else {
            result = 100 * (odd - 1);
        }
        return (result > 0 ? "+" : "") + Math.round(result);
    }
    static toDecimal(odd) {
        const decimalPart = odd.toString().split(".")[1];
        if (decimalPart != null && decimalPart.length > 2) {
            if (decimalPart.endsWith("0")) {
                return odd.toFixed(3).slice(0, -1);
            }
            return odd.toFixed(4).slice(0, -1);
        }
        return odd.toFixed(3).slice(0, -1);
    }
    static toFractional(odd) {
        odd -= 1;
        let bestFrac = `${Math.round(odd)}/1`;
        let bestFracVal = Math.round(odd);
        let bestErr = Math.abs(bestFracVal - odd);
        let fracVal;
        let err;
        for (let i = 2; i <= 200; i++) {
            fracVal = Math.round(odd * i) / i;
            err = Math.abs(fracVal - odd);
            if (err < bestErr) {
                bestFrac = `${Math.round(odd * i)}/${i}`;
                bestFracVal = fracVal;
                if (err === 0) {
                    break;
                }
                bestErr = err;
            }
        }
        return bestFrac;
    }
    static toHongKong(odd) {
        let result;
        if (odd <= 1 || Number.isNaN(odd)) {
            result = NaN;
        }
        else {
            result = odd - 1;
        }
        return OddFormatter.autoDecimalPoint
            ? OddFormatter.asianDecimal(result)
            : result.toFixed(OddFormatter.asianDecimalPoint);
    }
    static toIndonesian(odd) {
        let result;
        if (odd <= 1 || Number.isNaN(odd)) {
            result = NaN;
        }
        else if (odd >= 2) {
            result = odd - 1;
        }
        else {
            result = 1 / (1 - odd);
        }
        return OddFormatter.autoDecimalPoint
            ? OddFormatter.asianDecimal(result)
            : result.toFixed(OddFormatter.asianDecimalPoint);
    }
    static toMalay(odd) {
        let result;
        if (odd <= 1 || Number.isNaN(odd)) {
            result = NaN;
        }
        else if (odd <= 2) {
            result = odd - 1;
        }
        else {
            result = 1 / (1 - odd);
        }
        return OddFormatter.autoDecimalPoint
            ? OddFormatter.asianDecimal(result)
            : result.toFixed(OddFormatter.asianDecimalPoint);
    }
    static toProbability(odd) {
        const result = 100 / odd;
        return `${result.toFixed(2)}%`;
    }
    static asianDecimal(odd) {
        if (odd.toString().includes(".")) {
            const decimalPart = odd.toString().split(".")[1];
            return decimalPart.length > OddFormatter.asianDecimalPoint
                ? odd.toFixed(OddFormatter.asianDecimalPoint)
                : odd.toString();
        }
        return odd.toString();
    }
}
exports.OddFormatter = OddFormatter;
exports.default = OddFormatter;
//# sourceMappingURL=OddFormatter.js.map